/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as FarmerHarvestProofImport } from './routes/farmer-harvest-proof'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as AuthResetPasswordImport } from './routes/_auth/reset-password'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AppTransferYieldMapImport } from './routes/_app/transfer-yield-map'
import { Route as AppSupportImport } from './routes/_app/support'
import { Route as AppMapImport } from './routes/_app/map'
import { Route as AppIntercultureImport } from './routes/_app/interculture'
import { Route as AppInsuranceImport } from './routes/_app/insurance'
import { Route as AppHarvestProofImport } from './routes/_app/harvest-proof'
import { Route as AppFieldsImport } from './routes/_app/fields'
import { Route as AppDashboardImport } from './routes/_app/dashboard'
import { Route as AppAdminImport } from './routes/_app/_admin'
import { Route as AppFieldsFieldIdImport } from './routes/_app/fields_/$fieldId'
import { Route as AppAdminOrganisationsImport } from './routes/_app/_admin/organisations'
import { Route as AppFieldsFieldIdIndexImport } from './routes/_app/fields_/$fieldId/index'
import { Route as AppFieldsFieldIdEditImport } from './routes/_app/fields_/$fieldId_/edit'
import { Route as AppFieldsFieldIdCutImport } from './routes/_app/fields_/$fieldId_/cut'
import { Route as AppIntercultureCropFormIdResultImport } from './routes/_app/interculture_/$crop.$formId.result'
import { Route as AppFieldsFieldIdMapsMapTypeImport } from './routes/_app/fields_/$fieldId/maps/$mapType'
import { Route as AppIntercultureCropFormIdResultSatImagesImport } from './routes/_app/interculture_/$crop.$formId.result.sat-images'
import { Route as AppIntercultureCropFormIdResultMapsImport } from './routes/_app/interculture_/$crop.$formId.result.maps'

// Create Virtual Routes

const AuthLostPasswordLazyImport = createFileRoute('/_auth/lost-password')()
const AppSettingsLazyImport = createFileRoute('/_app/settings')()
const AppProfileLazyImport = createFileRoute('/_app/profile')()
const AppFieldsCreateLazyImport = createFileRoute('/_app/fields_/create')()
const AppAdminUsersLazyImport = createFileRoute('/_app/_admin/users')()
const AppAdminAccountsLazyImport = createFileRoute('/_app/_admin/accounts')()
const AppAdminUsersCreateLazyImport = createFileRoute(
  '/_app/_admin/users_/create',
)()
const AppAdminOrganisationsCreateLazyImport = createFileRoute(
  '/_app/_admin/organisations_/create',
)()
const AppAdminAccountsCreateLazyImport = createFileRoute(
  '/_app/_admin/accounts_/create',
)()
const AppAdminUsersUserIdEditLazyImport = createFileRoute(
  '/_app/_admin/users_/$userId/edit',
)()
const AppAdminOrganisationsOrganisationIdEditLazyImport = createFileRoute(
  '/_app/_admin/organisations_/$organisationId/edit',
)()
const AppAdminAccountsAccountIdEditLazyImport = createFileRoute(
  '/_app/_admin/accounts_/$accountId/edit',
)()

// Create/Update Routes

const FarmerHarvestProofRoute = FarmerHarvestProofImport.update({
  id: '/farmer-harvest-proof',
  path: '/farmer-harvest-proof',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthLostPasswordLazyRoute = AuthLostPasswordLazyImport.update({
  id: '/lost-password',
  path: '/lost-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/lost-password.lazy').then((d) => d.Route),
)

const AppSettingsLazyRoute = AppSettingsLazyImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/settings.lazy').then((d) => d.Route))

const AppProfileLazyRoute = AppProfileLazyImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/profile.lazy').then((d) => d.Route))

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const AppTransferYieldMapRoute = AppTransferYieldMapImport.update({
  id: '/transfer-yield-map',
  path: '/transfer-yield-map',
  getParentRoute: () => AppRoute,
} as any)

const AppSupportRoute = AppSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)

const AppMapRoute = AppMapImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppRoute,
} as any)

const AppIntercultureRoute = AppIntercultureImport.update({
  id: '/interculture',
  path: '/interculture',
  getParentRoute: () => AppRoute,
} as any)

const AppInsuranceRoute = AppInsuranceImport.update({
  id: '/insurance',
  path: '/insurance',
  getParentRoute: () => AppRoute,
} as any)

const AppHarvestProofRoute = AppHarvestProofImport.update({
  id: '/harvest-proof',
  path: '/harvest-proof',
  getParentRoute: () => AppRoute,
} as any)

const AppFieldsRoute = AppFieldsImport.update({
  id: '/fields',
  path: '/fields',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardRoute = AppDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminRoute = AppAdminImport.update({
  id: '/_admin',
  getParentRoute: () => AppRoute,
} as any)

const AppFieldsCreateLazyRoute = AppFieldsCreateLazyImport.update({
  id: '/fields_/create',
  path: '/fields/create',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/fields_/create.lazy').then((d) => d.Route),
)

const AppAdminUsersLazyRoute = AppAdminUsersLazyImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any).lazy(() =>
  import('./routes/_app/_admin/users.lazy').then((d) => d.Route),
)

const AppAdminAccountsLazyRoute = AppAdminAccountsLazyImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppAdminRoute,
} as any).lazy(() =>
  import('./routes/_app/_admin/accounts.lazy').then((d) => d.Route),
)

const AppFieldsFieldIdRoute = AppFieldsFieldIdImport.update({
  id: '/fields_/$fieldId',
  path: '/fields/$fieldId',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminOrganisationsRoute = AppAdminOrganisationsImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppFieldsFieldIdIndexRoute = AppFieldsFieldIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFieldsFieldIdRoute,
} as any)

const AppAdminUsersCreateLazyRoute = AppAdminUsersCreateLazyImport.update({
  id: '/users_/create',
  path: '/users/create',
  getParentRoute: () => AppAdminRoute,
} as any).lazy(() =>
  import('./routes/_app/_admin/users_/create.lazy').then((d) => d.Route),
)

const AppAdminOrganisationsCreateLazyRoute =
  AppAdminOrganisationsCreateLazyImport.update({
    id: '/organisations_/create',
    path: '/organisations/create',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import('./routes/_app/_admin/organisations_/create.lazy').then(
      (d) => d.Route,
    ),
  )

const AppAdminAccountsCreateLazyRoute = AppAdminAccountsCreateLazyImport.update(
  {
    id: '/accounts_/create',
    path: '/accounts/create',
    getParentRoute: () => AppAdminRoute,
  } as any,
).lazy(() =>
  import('./routes/_app/_admin/accounts_/create.lazy').then((d) => d.Route),
)

const AppFieldsFieldIdEditRoute = AppFieldsFieldIdEditImport.update({
  id: '/fields_/$fieldId_/edit',
  path: '/fields/$fieldId/edit',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/fields_/$fieldId_/edit.lazy').then((d) => d.Route),
)

const AppFieldsFieldIdCutRoute = AppFieldsFieldIdCutImport.update({
  id: '/fields_/$fieldId_/cut',
  path: '/fields/$fieldId/cut',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/fields_/$fieldId_/cut.lazy').then((d) => d.Route),
)

const AppAdminUsersUserIdEditLazyRoute =
  AppAdminUsersUserIdEditLazyImport.update({
    id: '/users_/$userId/edit',
    path: '/users/$userId/edit',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import('./routes/_app/_admin/users_/$userId.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AppAdminOrganisationsOrganisationIdEditLazyRoute =
  AppAdminOrganisationsOrganisationIdEditLazyImport.update({
    id: '/organisations_/$organisationId/edit',
    path: '/organisations/$organisationId/edit',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import(
      './routes/_app/_admin/organisations_/$organisationId.edit.lazy'
    ).then((d) => d.Route),
  )

const AppAdminAccountsAccountIdEditLazyRoute =
  AppAdminAccountsAccountIdEditLazyImport.update({
    id: '/accounts_/$accountId/edit',
    path: '/accounts/$accountId/edit',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import('./routes/_app/_admin/accounts_/$accountId.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AppIntercultureCropFormIdResultRoute =
  AppIntercultureCropFormIdResultImport.update({
    id: '/interculture_/$crop/$formId/result',
    path: '/interculture/$crop/$formId/result',
    getParentRoute: () => AppRoute,
  } as any)

const AppFieldsFieldIdMapsMapTypeRoute =
  AppFieldsFieldIdMapsMapTypeImport.update({
    id: '/maps/$mapType',
    path: '/maps/$mapType',
    getParentRoute: () => AppFieldsFieldIdRoute,
  } as any)

const AppIntercultureCropFormIdResultSatImagesRoute =
  AppIntercultureCropFormIdResultSatImagesImport.update({
    id: '/sat-images',
    path: '/sat-images',
    getParentRoute: () => AppIntercultureCropFormIdResultRoute,
  } as any)

const AppIntercultureCropFormIdResultMapsRoute =
  AppIntercultureCropFormIdResultMapsImport.update({
    id: '/maps',
    path: '/maps',
    getParentRoute: () => AppIntercultureCropFormIdResultRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/farmer-harvest-proof': {
      id: '/farmer-harvest-proof'
      path: '/farmer-harvest-proof'
      fullPath: '/farmer-harvest-proof'
      preLoaderRoute: typeof FarmerHarvestProofImport
      parentRoute: typeof rootRoute
    }
    '/_app/_admin': {
      id: '/_app/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppAdminImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/fields': {
      id: '/_app/fields'
      path: '/fields'
      fullPath: '/fields'
      preLoaderRoute: typeof AppFieldsImport
      parentRoute: typeof AppImport
    }
    '/_app/harvest-proof': {
      id: '/_app/harvest-proof'
      path: '/harvest-proof'
      fullPath: '/harvest-proof'
      preLoaderRoute: typeof AppHarvestProofImport
      parentRoute: typeof AppImport
    }
    '/_app/insurance': {
      id: '/_app/insurance'
      path: '/insurance'
      fullPath: '/insurance'
      preLoaderRoute: typeof AppInsuranceImport
      parentRoute: typeof AppImport
    }
    '/_app/interculture': {
      id: '/_app/interculture'
      path: '/interculture'
      fullPath: '/interculture'
      preLoaderRoute: typeof AppIntercultureImport
      parentRoute: typeof AppImport
    }
    '/_app/map': {
      id: '/_app/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof AppMapImport
      parentRoute: typeof AppImport
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportImport
      parentRoute: typeof AppImport
    }
    '/_app/transfer-yield-map': {
      id: '/_app/transfer-yield-map'
      path: '/transfer-yield-map'
      fullPath: '/transfer-yield-map'
      preLoaderRoute: typeof AppTransferYieldMapImport
      parentRoute: typeof AppImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsLazyImport
      parentRoute: typeof AppImport
    }
    '/_auth/lost-password': {
      id: '/_auth/lost-password'
      path: '/lost-password'
      fullPath: '/lost-password'
      preLoaderRoute: typeof AuthLostPasswordLazyImport
      parentRoute: typeof AuthImport
    }
    '/_app/_admin/organisations': {
      id: '/_app/_admin/organisations'
      path: '/organisations'
      fullPath: '/organisations'
      preLoaderRoute: typeof AppAdminOrganisationsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/fields_/$fieldId': {
      id: '/_app/fields_/$fieldId'
      path: '/fields/$fieldId'
      fullPath: '/fields/$fieldId'
      preLoaderRoute: typeof AppFieldsFieldIdImport
      parentRoute: typeof AppImport
    }
    '/_app/_admin/accounts': {
      id: '/_app/_admin/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAdminAccountsLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/users': {
      id: '/_app/_admin/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppAdminUsersLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/fields_/create': {
      id: '/_app/fields_/create'
      path: '/fields/create'
      fullPath: '/fields/create'
      preLoaderRoute: typeof AppFieldsCreateLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/fields_/$fieldId_/cut': {
      id: '/_app/fields_/$fieldId_/cut'
      path: '/fields/$fieldId/cut'
      fullPath: '/fields/$fieldId/cut'
      preLoaderRoute: typeof AppFieldsFieldIdCutImport
      parentRoute: typeof AppImport
    }
    '/_app/fields_/$fieldId_/edit': {
      id: '/_app/fields_/$fieldId_/edit'
      path: '/fields/$fieldId/edit'
      fullPath: '/fields/$fieldId/edit'
      preLoaderRoute: typeof AppFieldsFieldIdEditImport
      parentRoute: typeof AppImport
    }
    '/_app/_admin/accounts_/create': {
      id: '/_app/_admin/accounts_/create'
      path: '/accounts/create'
      fullPath: '/accounts/create'
      preLoaderRoute: typeof AppAdminAccountsCreateLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/organisations_/create': {
      id: '/_app/_admin/organisations_/create'
      path: '/organisations/create'
      fullPath: '/organisations/create'
      preLoaderRoute: typeof AppAdminOrganisationsCreateLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/users_/create': {
      id: '/_app/_admin/users_/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof AppAdminUsersCreateLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/fields_/$fieldId/': {
      id: '/_app/fields_/$fieldId/'
      path: '/'
      fullPath: '/fields/$fieldId/'
      preLoaderRoute: typeof AppFieldsFieldIdIndexImport
      parentRoute: typeof AppFieldsFieldIdImport
    }
    '/_app/fields_/$fieldId/maps/$mapType': {
      id: '/_app/fields_/$fieldId/maps/$mapType'
      path: '/maps/$mapType'
      fullPath: '/fields/$fieldId/maps/$mapType'
      preLoaderRoute: typeof AppFieldsFieldIdMapsMapTypeImport
      parentRoute: typeof AppFieldsFieldIdImport
    }
    '/_app/interculture_/$crop/$formId/result': {
      id: '/_app/interculture_/$crop/$formId/result'
      path: '/interculture/$crop/$formId/result'
      fullPath: '/interculture/$crop/$formId/result'
      preLoaderRoute: typeof AppIntercultureCropFormIdResultImport
      parentRoute: typeof AppImport
    }
    '/_app/_admin/accounts_/$accountId/edit': {
      id: '/_app/_admin/accounts_/$accountId/edit'
      path: '/accounts/$accountId/edit'
      fullPath: '/accounts/$accountId/edit'
      preLoaderRoute: typeof AppAdminAccountsAccountIdEditLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/organisations_/$organisationId/edit': {
      id: '/_app/_admin/organisations_/$organisationId/edit'
      path: '/organisations/$organisationId/edit'
      fullPath: '/organisations/$organisationId/edit'
      preLoaderRoute: typeof AppAdminOrganisationsOrganisationIdEditLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/users_/$userId/edit': {
      id: '/_app/_admin/users_/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof AppAdminUsersUserIdEditLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/interculture_/$crop/$formId/result/maps': {
      id: '/_app/interculture_/$crop/$formId/result/maps'
      path: '/maps'
      fullPath: '/interculture/$crop/$formId/result/maps'
      preLoaderRoute: typeof AppIntercultureCropFormIdResultMapsImport
      parentRoute: typeof AppIntercultureCropFormIdResultImport
    }
    '/_app/interculture_/$crop/$formId/result/sat-images': {
      id: '/_app/interculture_/$crop/$formId/result/sat-images'
      path: '/sat-images'
      fullPath: '/interculture/$crop/$formId/result/sat-images'
      preLoaderRoute: typeof AppIntercultureCropFormIdResultSatImagesImport
      parentRoute: typeof AppIntercultureCropFormIdResultImport
    }
  }
}

// Create and export the route tree

interface AppAdminRouteChildren {
  AppAdminOrganisationsRoute: typeof AppAdminOrganisationsRoute
  AppAdminAccountsLazyRoute: typeof AppAdminAccountsLazyRoute
  AppAdminUsersLazyRoute: typeof AppAdminUsersLazyRoute
  AppAdminAccountsCreateLazyRoute: typeof AppAdminAccountsCreateLazyRoute
  AppAdminOrganisationsCreateLazyRoute: typeof AppAdminOrganisationsCreateLazyRoute
  AppAdminUsersCreateLazyRoute: typeof AppAdminUsersCreateLazyRoute
  AppAdminAccountsAccountIdEditLazyRoute: typeof AppAdminAccountsAccountIdEditLazyRoute
  AppAdminOrganisationsOrganisationIdEditLazyRoute: typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  AppAdminUsersUserIdEditLazyRoute: typeof AppAdminUsersUserIdEditLazyRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminOrganisationsRoute: AppAdminOrganisationsRoute,
  AppAdminAccountsLazyRoute: AppAdminAccountsLazyRoute,
  AppAdminUsersLazyRoute: AppAdminUsersLazyRoute,
  AppAdminAccountsCreateLazyRoute: AppAdminAccountsCreateLazyRoute,
  AppAdminOrganisationsCreateLazyRoute: AppAdminOrganisationsCreateLazyRoute,
  AppAdminUsersCreateLazyRoute: AppAdminUsersCreateLazyRoute,
  AppAdminAccountsAccountIdEditLazyRoute:
    AppAdminAccountsAccountIdEditLazyRoute,
  AppAdminOrganisationsOrganisationIdEditLazyRoute:
    AppAdminOrganisationsOrganisationIdEditLazyRoute,
  AppAdminUsersUserIdEditLazyRoute: AppAdminUsersUserIdEditLazyRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppFieldsFieldIdRouteChildren {
  AppFieldsFieldIdIndexRoute: typeof AppFieldsFieldIdIndexRoute
  AppFieldsFieldIdMapsMapTypeRoute: typeof AppFieldsFieldIdMapsMapTypeRoute
}

const AppFieldsFieldIdRouteChildren: AppFieldsFieldIdRouteChildren = {
  AppFieldsFieldIdIndexRoute: AppFieldsFieldIdIndexRoute,
  AppFieldsFieldIdMapsMapTypeRoute: AppFieldsFieldIdMapsMapTypeRoute,
}

const AppFieldsFieldIdRouteWithChildren =
  AppFieldsFieldIdRoute._addFileChildren(AppFieldsFieldIdRouteChildren)

interface AppIntercultureCropFormIdResultRouteChildren {
  AppIntercultureCropFormIdResultMapsRoute: typeof AppIntercultureCropFormIdResultMapsRoute
  AppIntercultureCropFormIdResultSatImagesRoute: typeof AppIntercultureCropFormIdResultSatImagesRoute
}

const AppIntercultureCropFormIdResultRouteChildren: AppIntercultureCropFormIdResultRouteChildren =
  {
    AppIntercultureCropFormIdResultMapsRoute:
      AppIntercultureCropFormIdResultMapsRoute,
    AppIntercultureCropFormIdResultSatImagesRoute:
      AppIntercultureCropFormIdResultSatImagesRoute,
  }

const AppIntercultureCropFormIdResultRouteWithChildren =
  AppIntercultureCropFormIdResultRoute._addFileChildren(
    AppIntercultureCropFormIdResultRouteChildren,
  )

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppFieldsRoute: typeof AppFieldsRoute
  AppHarvestProofRoute: typeof AppHarvestProofRoute
  AppInsuranceRoute: typeof AppInsuranceRoute
  AppIntercultureRoute: typeof AppIntercultureRoute
  AppMapRoute: typeof AppMapRoute
  AppSupportRoute: typeof AppSupportRoute
  AppTransferYieldMapRoute: typeof AppTransferYieldMapRoute
  AppProfileLazyRoute: typeof AppProfileLazyRoute
  AppSettingsLazyRoute: typeof AppSettingsLazyRoute
  AppFieldsFieldIdRoute: typeof AppFieldsFieldIdRouteWithChildren
  AppFieldsCreateLazyRoute: typeof AppFieldsCreateLazyRoute
  AppFieldsFieldIdCutRoute: typeof AppFieldsFieldIdCutRoute
  AppFieldsFieldIdEditRoute: typeof AppFieldsFieldIdEditRoute
  AppIntercultureCropFormIdResultRoute: typeof AppIntercultureCropFormIdResultRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppFieldsRoute: AppFieldsRoute,
  AppHarvestProofRoute: AppHarvestProofRoute,
  AppInsuranceRoute: AppInsuranceRoute,
  AppIntercultureRoute: AppIntercultureRoute,
  AppMapRoute: AppMapRoute,
  AppSupportRoute: AppSupportRoute,
  AppTransferYieldMapRoute: AppTransferYieldMapRoute,
  AppProfileLazyRoute: AppProfileLazyRoute,
  AppSettingsLazyRoute: AppSettingsLazyRoute,
  AppFieldsFieldIdRoute: AppFieldsFieldIdRouteWithChildren,
  AppFieldsCreateLazyRoute: AppFieldsCreateLazyRoute,
  AppFieldsFieldIdCutRoute: AppFieldsFieldIdCutRoute,
  AppFieldsFieldIdEditRoute: AppFieldsFieldIdEditRoute,
  AppIntercultureCropFormIdResultRoute:
    AppIntercultureCropFormIdResultRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthLostPasswordLazyRoute: typeof AuthLostPasswordLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthLostPasswordLazyRoute: AuthLostPasswordLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AppAdminRouteWithChildren
  '/farmer-harvest-proof': typeof FarmerHarvestProofRoute
  '/dashboard': typeof AppDashboardRoute
  '/fields': typeof AppFieldsRoute
  '/harvest-proof': typeof AppHarvestProofRoute
  '/insurance': typeof AppInsuranceRoute
  '/interculture': typeof AppIntercultureRoute
  '/map': typeof AppMapRoute
  '/support': typeof AppSupportRoute
  '/transfer-yield-map': typeof AppTransferYieldMapRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/profile': typeof AppProfileLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/lost-password': typeof AuthLostPasswordLazyRoute
  '/organisations': typeof AppAdminOrganisationsRoute
  '/fields/$fieldId': typeof AppFieldsFieldIdRouteWithChildren
  '/accounts': typeof AppAdminAccountsLazyRoute
  '/users': typeof AppAdminUsersLazyRoute
  '/fields/create': typeof AppFieldsCreateLazyRoute
  '/fields/$fieldId/cut': typeof AppFieldsFieldIdCutRoute
  '/fields/$fieldId/edit': typeof AppFieldsFieldIdEditRoute
  '/accounts/create': typeof AppAdminAccountsCreateLazyRoute
  '/organisations/create': typeof AppAdminOrganisationsCreateLazyRoute
  '/users/create': typeof AppAdminUsersCreateLazyRoute
  '/fields/$fieldId/': typeof AppFieldsFieldIdIndexRoute
  '/fields/$fieldId/maps/$mapType': typeof AppFieldsFieldIdMapsMapTypeRoute
  '/interculture/$crop/$formId/result': typeof AppIntercultureCropFormIdResultRouteWithChildren
  '/accounts/$accountId/edit': typeof AppAdminAccountsAccountIdEditLazyRoute
  '/organisations/$organisationId/edit': typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  '/users/$userId/edit': typeof AppAdminUsersUserIdEditLazyRoute
  '/interculture/$crop/$formId/result/maps': typeof AppIntercultureCropFormIdResultMapsRoute
  '/interculture/$crop/$formId/result/sat-images': typeof AppIntercultureCropFormIdResultSatImagesRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AppAdminRouteWithChildren
  '/farmer-harvest-proof': typeof FarmerHarvestProofRoute
  '/dashboard': typeof AppDashboardRoute
  '/fields': typeof AppFieldsRoute
  '/harvest-proof': typeof AppHarvestProofRoute
  '/insurance': typeof AppInsuranceRoute
  '/interculture': typeof AppIntercultureRoute
  '/map': typeof AppMapRoute
  '/support': typeof AppSupportRoute
  '/transfer-yield-map': typeof AppTransferYieldMapRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/profile': typeof AppProfileLazyRoute
  '/settings': typeof AppSettingsLazyRoute
  '/lost-password': typeof AuthLostPasswordLazyRoute
  '/organisations': typeof AppAdminOrganisationsRoute
  '/accounts': typeof AppAdminAccountsLazyRoute
  '/users': typeof AppAdminUsersLazyRoute
  '/fields/create': typeof AppFieldsCreateLazyRoute
  '/fields/$fieldId/cut': typeof AppFieldsFieldIdCutRoute
  '/fields/$fieldId/edit': typeof AppFieldsFieldIdEditRoute
  '/accounts/create': typeof AppAdminAccountsCreateLazyRoute
  '/organisations/create': typeof AppAdminOrganisationsCreateLazyRoute
  '/users/create': typeof AppAdminUsersCreateLazyRoute
  '/fields/$fieldId': typeof AppFieldsFieldIdIndexRoute
  '/fields/$fieldId/maps/$mapType': typeof AppFieldsFieldIdMapsMapTypeRoute
  '/interculture/$crop/$formId/result': typeof AppIntercultureCropFormIdResultRouteWithChildren
  '/accounts/$accountId/edit': typeof AppAdminAccountsAccountIdEditLazyRoute
  '/organisations/$organisationId/edit': typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  '/users/$userId/edit': typeof AppAdminUsersUserIdEditLazyRoute
  '/interculture/$crop/$formId/result/maps': typeof AppIntercultureCropFormIdResultMapsRoute
  '/interculture/$crop/$formId/result/sat-images': typeof AppIntercultureCropFormIdResultSatImagesRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/farmer-harvest-proof': typeof FarmerHarvestProofRoute
  '/_app/_admin': typeof AppAdminRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/fields': typeof AppFieldsRoute
  '/_app/harvest-proof': typeof AppHarvestProofRoute
  '/_app/insurance': typeof AppInsuranceRoute
  '/_app/interculture': typeof AppIntercultureRoute
  '/_app/map': typeof AppMapRoute
  '/_app/support': typeof AppSupportRoute
  '/_app/transfer-yield-map': typeof AppTransferYieldMapRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_app/profile': typeof AppProfileLazyRoute
  '/_app/settings': typeof AppSettingsLazyRoute
  '/_auth/lost-password': typeof AuthLostPasswordLazyRoute
  '/_app/_admin/organisations': typeof AppAdminOrganisationsRoute
  '/_app/fields_/$fieldId': typeof AppFieldsFieldIdRouteWithChildren
  '/_app/_admin/accounts': typeof AppAdminAccountsLazyRoute
  '/_app/_admin/users': typeof AppAdminUsersLazyRoute
  '/_app/fields_/create': typeof AppFieldsCreateLazyRoute
  '/_app/fields_/$fieldId_/cut': typeof AppFieldsFieldIdCutRoute
  '/_app/fields_/$fieldId_/edit': typeof AppFieldsFieldIdEditRoute
  '/_app/_admin/accounts_/create': typeof AppAdminAccountsCreateLazyRoute
  '/_app/_admin/organisations_/create': typeof AppAdminOrganisationsCreateLazyRoute
  '/_app/_admin/users_/create': typeof AppAdminUsersCreateLazyRoute
  '/_app/fields_/$fieldId/': typeof AppFieldsFieldIdIndexRoute
  '/_app/fields_/$fieldId/maps/$mapType': typeof AppFieldsFieldIdMapsMapTypeRoute
  '/_app/interculture_/$crop/$formId/result': typeof AppIntercultureCropFormIdResultRouteWithChildren
  '/_app/_admin/accounts_/$accountId/edit': typeof AppAdminAccountsAccountIdEditLazyRoute
  '/_app/_admin/organisations_/$organisationId/edit': typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  '/_app/_admin/users_/$userId/edit': typeof AppAdminUsersUserIdEditLazyRoute
  '/_app/interculture_/$crop/$formId/result/maps': typeof AppIntercultureCropFormIdResultMapsRoute
  '/_app/interculture_/$crop/$formId/result/sat-images': typeof AppIntercultureCropFormIdResultSatImagesRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/farmer-harvest-proof'
    | '/dashboard'
    | '/fields'
    | '/harvest-proof'
    | '/insurance'
    | '/interculture'
    | '/map'
    | '/support'
    | '/transfer-yield-map'
    | '/login'
    | '/reset-password'
    | '/profile'
    | '/settings'
    | '/lost-password'
    | '/organisations'
    | '/fields/$fieldId'
    | '/accounts'
    | '/users'
    | '/fields/create'
    | '/fields/$fieldId/cut'
    | '/fields/$fieldId/edit'
    | '/accounts/create'
    | '/organisations/create'
    | '/users/create'
    | '/fields/$fieldId/'
    | '/fields/$fieldId/maps/$mapType'
    | '/interculture/$crop/$formId/result'
    | '/accounts/$accountId/edit'
    | '/organisations/$organisationId/edit'
    | '/users/$userId/edit'
    | '/interculture/$crop/$formId/result/maps'
    | '/interculture/$crop/$formId/result/sat-images'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/farmer-harvest-proof'
    | '/dashboard'
    | '/fields'
    | '/harvest-proof'
    | '/insurance'
    | '/interculture'
    | '/map'
    | '/support'
    | '/transfer-yield-map'
    | '/login'
    | '/reset-password'
    | '/profile'
    | '/settings'
    | '/lost-password'
    | '/organisations'
    | '/accounts'
    | '/users'
    | '/fields/create'
    | '/fields/$fieldId/cut'
    | '/fields/$fieldId/edit'
    | '/accounts/create'
    | '/organisations/create'
    | '/users/create'
    | '/fields/$fieldId'
    | '/fields/$fieldId/maps/$mapType'
    | '/interculture/$crop/$formId/result'
    | '/accounts/$accountId/edit'
    | '/organisations/$organisationId/edit'
    | '/users/$userId/edit'
    | '/interculture/$crop/$formId/result/maps'
    | '/interculture/$crop/$formId/result/sat-images'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/farmer-harvest-proof'
    | '/_app/_admin'
    | '/_app/dashboard'
    | '/_app/fields'
    | '/_app/harvest-proof'
    | '/_app/insurance'
    | '/_app/interculture'
    | '/_app/map'
    | '/_app/support'
    | '/_app/transfer-yield-map'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_app/profile'
    | '/_app/settings'
    | '/_auth/lost-password'
    | '/_app/_admin/organisations'
    | '/_app/fields_/$fieldId'
    | '/_app/_admin/accounts'
    | '/_app/_admin/users'
    | '/_app/fields_/create'
    | '/_app/fields_/$fieldId_/cut'
    | '/_app/fields_/$fieldId_/edit'
    | '/_app/_admin/accounts_/create'
    | '/_app/_admin/organisations_/create'
    | '/_app/_admin/users_/create'
    | '/_app/fields_/$fieldId/'
    | '/_app/fields_/$fieldId/maps/$mapType'
    | '/_app/interculture_/$crop/$formId/result'
    | '/_app/_admin/accounts_/$accountId/edit'
    | '/_app/_admin/organisations_/$organisationId/edit'
    | '/_app/_admin/users_/$userId/edit'
    | '/_app/interculture_/$crop/$formId/result/maps'
    | '/_app/interculture_/$crop/$formId/result/sat-images'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  FarmerHarvestProofRoute: typeof FarmerHarvestProofRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  FarmerHarvestProofRoute: FarmerHarvestProofRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/_auth",
        "/farmer-harvest-proof"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/_admin",
        "/_app/dashboard",
        "/_app/fields",
        "/_app/harvest-proof",
        "/_app/insurance",
        "/_app/interculture",
        "/_app/map",
        "/_app/support",
        "/_app/transfer-yield-map",
        "/_app/profile",
        "/_app/settings",
        "/_app/fields_/$fieldId",
        "/_app/fields_/create",
        "/_app/fields_/$fieldId_/cut",
        "/_app/fields_/$fieldId_/edit",
        "/_app/interculture_/$crop/$formId/result"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/reset-password",
        "/_auth/lost-password"
      ]
    },
    "/farmer-harvest-proof": {
      "filePath": "farmer-harvest-proof.tsx"
    },
    "/_app/_admin": {
      "filePath": "_app/_admin.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_admin/organisations",
        "/_app/_admin/accounts",
        "/_app/_admin/users",
        "/_app/_admin/accounts_/create",
        "/_app/_admin/organisations_/create",
        "/_app/_admin/users_/create",
        "/_app/_admin/accounts_/$accountId/edit",
        "/_app/_admin/organisations_/$organisationId/edit",
        "/_app/_admin/users_/$userId/edit"
      ]
    },
    "/_app/dashboard": {
      "filePath": "_app/dashboard.tsx",
      "parent": "/_app"
    },
    "/_app/fields": {
      "filePath": "_app/fields.tsx",
      "parent": "/_app"
    },
    "/_app/harvest-proof": {
      "filePath": "_app/harvest-proof.tsx",
      "parent": "/_app"
    },
    "/_app/insurance": {
      "filePath": "_app/insurance.tsx",
      "parent": "/_app"
    },
    "/_app/interculture": {
      "filePath": "_app/interculture.tsx",
      "parent": "/_app"
    },
    "/_app/map": {
      "filePath": "_app/map.tsx",
      "parent": "/_app"
    },
    "/_app/support": {
      "filePath": "_app/support.tsx",
      "parent": "/_app"
    },
    "/_app/transfer-yield-map": {
      "filePath": "_app/transfer-yield-map.tsx",
      "parent": "/_app"
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_auth/reset-password": {
      "filePath": "_auth/reset-password.tsx",
      "parent": "/_auth"
    },
    "/_app/profile": {
      "filePath": "_app/profile.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/settings": {
      "filePath": "_app/settings.lazy.tsx",
      "parent": "/_app"
    },
    "/_auth/lost-password": {
      "filePath": "_auth/lost-password.lazy.tsx",
      "parent": "/_auth"
    },
    "/_app/_admin/organisations": {
      "filePath": "_app/_admin/organisations.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/fields_/$fieldId": {
      "filePath": "_app/fields_/$fieldId.tsx",
      "parent": "/_app",
      "children": [
        "/_app/fields_/$fieldId/",
        "/_app/fields_/$fieldId/maps/$mapType"
      ]
    },
    "/_app/_admin/accounts": {
      "filePath": "_app/_admin/accounts.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/users": {
      "filePath": "_app/_admin/users.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/fields_/create": {
      "filePath": "_app/fields_/create.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/fields_/$fieldId_/cut": {
      "filePath": "_app/fields_/$fieldId_/cut.tsx",
      "parent": "/_app"
    },
    "/_app/fields_/$fieldId_/edit": {
      "filePath": "_app/fields_/$fieldId_/edit.tsx",
      "parent": "/_app"
    },
    "/_app/_admin/accounts_/create": {
      "filePath": "_app/_admin/accounts_/create.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/organisations_/create": {
      "filePath": "_app/_admin/organisations_/create.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/users_/create": {
      "filePath": "_app/_admin/users_/create.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/fields_/$fieldId/": {
      "filePath": "_app/fields_/$fieldId/index.tsx",
      "parent": "/_app/fields_/$fieldId"
    },
    "/_app/fields_/$fieldId/maps/$mapType": {
      "filePath": "_app/fields_/$fieldId/maps/$mapType.tsx",
      "parent": "/_app/fields_/$fieldId"
    },
    "/_app/interculture_/$crop/$formId/result": {
      "filePath": "_app/interculture_/$crop.$formId.result.tsx",
      "parent": "/_app",
      "children": [
        "/_app/interculture_/$crop/$formId/result/maps",
        "/_app/interculture_/$crop/$formId/result/sat-images"
      ]
    },
    "/_app/_admin/accounts_/$accountId/edit": {
      "filePath": "_app/_admin/accounts_/$accountId.edit.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/organisations_/$organisationId/edit": {
      "filePath": "_app/_admin/organisations_/$organisationId.edit.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/users_/$userId/edit": {
      "filePath": "_app/_admin/users_/$userId.edit.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/interculture_/$crop/$formId/result/maps": {
      "filePath": "_app/interculture_/$crop.$formId.result.maps.tsx",
      "parent": "/_app/interculture_/$crop/$formId/result"
    },
    "/_app/interculture_/$crop/$formId/result/sat-images": {
      "filePath": "_app/interculture_/$crop.$formId.result.sat-images.tsx",
      "parent": "/_app/interculture_/$crop/$formId/result"
    }
  }
}
ROUTE_MANIFEST_END */
